const initialState = {
    isModalVisible: false,
  };
  
  const adReportModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_AD_REPORT_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_AD_REPORT_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default adReportModalReducer;
  